<editor #tinyMceEditor [init]="editorOptions" [formControl]="ctrl" [disabled]="disabled" *ngIf="showEditor"></editor>
